import React from "react";
import {useModel} from "../../models";
import style from "./MainLayout.module.scss";
import {Avatar, Layout} from "antd";
import AppMenu from "./AppMenu";
import {
    UserOutlined,
} from '@ant-design/icons';
import scmLogo from "../../assets/images/scm_logo.png";
import scmLogo0 from "../../assets/images/scm_logo_0.png";

const {Sider} = Layout;
const AppSider = () => {
    const [{collapsed}] = useModel("menuState");
    return <Sider
        width={226}
        style={{height: "100%"}}
        trigger={null}
        collapsible
        collapsed={collapsed}
    >
        <div className={style.logo}>
            {
                /*collapsed ? <Avatar
                    style={{backgroundColor: '#87d068'}}
                    icon={<UserOutlined/>}
                /> : "供应链管理系统"*/
                collapsed ? <img style={{width: "32px"}} src={scmLogo}/> : <img style={{width: "100px"}} src={scmLogo0}/>
            }
        </div>
        <AppMenu/>
    </Sider>
}

export default AppSider;